// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--dark.v-list[data-v-1d2ae81a]{background-color:#fff}", ""]);
// Exports
module.exports = exports;
